import React from 'react';
import Icon from '../../../components/AppIcon';

const CredentialsSection = () => {
  const credentials = [
    {
      category: "Professional Certifications",
      items: [
        {
          title: "Certified Valuation Analyst (CVA)",
          issuer: "National Association of Certified Valuators & Analysts",
          // year: "2018",
          icon: "Award"
        },
        {
          title: "Certified Public Accountant (CPA)",
          issuer: "American Institute of Certified Public Accountants",
          // year: "2019",
          icon: "Award"
        },
        {
          title: "Certified Financial Modeling & Valuation Analyst (FMVA)",
          issuer: "Corporate Finance Institute",
          // year: "2020",
          icon: "Star"
        }
      ]
    },
    // {
    //   category: "Court Qualifications",
    //   items: [
    //     {
    //       title: "Expert Witness Certification",
    //       issuer: "UAE Courts System",
    //       year: "2019",
    //       icon: "Scale"
    //     },
    //     {
    //       title: "Court-Nominable Valuer",
    //       issuer: "Bahrain Commercial Courts",
    //       year: "2020",
    //       icon: "Gavel"
    //     },
    //     {
    //       title: "Litigation Support Specialist",
    //       issuer: "Saudi Commercial Court",
    //       year: "2021",
    //       icon: "FileText"
    //     }
    //   ]
    // },
    {
      category: "Professional Memberships",
      items: [
        {
          title: "National Association of Certified Valuators & Analysts",
          issuer: "Member",
          // year: "2018",
          icon: "Globe"
        },
        {
          title: "American Institute of Certified Public Accountants",
          issuer: "Member",
          // year: "2017",
          icon: "Building"
        },
        {
          title: "The Society of Professional Consultants",
          issuer: "Member",
          // year: "2019",
          icon: "Users"
        }
      ]
    }
  ];

  return (
    <div className="bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold text-text-primary mb-4">
            Professional Credentials & Qualifications
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our certifications and memberships demonstrate our commitment to the highest professional standards and continuous education in valuation practices.          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {credentials?.map((section, sectionIndex) => (
            <div key={sectionIndex} className="bg-card rounded-xl shadow-brand border border-border p-6">
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-text-primary mb-2">
                  {section?.category}
                </h3>
                <div className="w-12 h-1 bg-accent rounded-full"></div>
              </div>

              <div className="space-y-4">
                {section?.items?.map((item, itemIndex) => (
                  <div key={itemIndex} className="flex items-start space-x-4 p-4 rounded-lg hover:bg-muted/50 transition-colors duration-200">
                    <div className="flex-shrink-0">
                      <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
                        <Icon name={item?.icon} size={20} className="text-accent" />
                      </div>
                    </div>

                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-semibold text-text-primary mb-1">
                        {item?.title}
                      </h4>
                      <p className="text-sm text-text-secondary mb-1">
                        {item?.issuer}
                      </p>
                      {/* <div className="flex items-center">
                        <Icon name="Calendar" size={14} className="text-text-muted mr-1" />
                        <span className="text-xs text-text-muted">Since {item?.year}</span>
                      </div> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Continuing Education */}
        {/* <div className="mt-12 bg-muted/30 rounded-xl p-8">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mb-4">
              <Icon name="BookOpen" size={32} className="text-accent" />
            </div>
            <h3 className="text-xl font-semibold text-text-primary mb-3">
              Continuing Professional Development
            </h3>
            <p className="text-text-secondary mb-6 max-w-2xl mx-auto">
              We maintain our professional edge through continuous learning, attending over 40 hours of specialized training annually and staying current with evolving valuation standards and market practices.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="text-center">
                <div className="text-2xl font-bold text-accent mb-1">40+</div>
                <div className="text-sm text-text-secondary">Annual CPD Hours</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent mb-1">15+</div>
                <div className="text-sm text-text-secondary">Industry Conferences</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent mb-1">8+</div>
                <div className="text-sm text-text-secondary">Professional Courses</div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default CredentialsSection;